.tooltip {
  --ixf-tooltip-font-color: var(--ixf-color-background);
  --ixf-tooltip-background: var(--ixf-text-tone-md);

  // Size, default: small
  --ixf-tooltip-padding: var(--ixf-space-2);

  user-select: none;
  padding: var(--ixf-tooltip-padding);
  border-radius: 6px;
  background: var(--ixf-tooltip-background);
  box-shadow: var(--ixf-box-shadow-tooltip);
  color: var(--ixf-tooltip-font-color);
  font-family: var(--ixf-font-family-main);
  font-size: 0.75rem;
  font-weight: var(--ixf-font-weight-main-medium);
  line-height: 1rem;
  position: relative;
  z-index: 9999999;

  &.size-large {
    --ixf-tooltip-padding: 15px var(--ixf-space-4);
    border-radius: var(--ixf-border-radius-2);
    font-size: 0.875rem;
    line-height: 1.125rem;
  }

  .arrow {
    fill: var(--ixf-tooltip-background);
  }

  &[data-state='delayed-open'] {
    animation: fadeIn 200ms ease;
  }

  &[data-state='closed'] {
    animation: fadeOut 200ms ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
